"use strict";
import _ from 'lodash';
window._ = _;

require('./polyfill');
require('@prism/styles/prism.comps.sandbox.min.css');

require("shared/sass/main.scss"); // TODO: just load what css is needed for this module
require("shared/sass/flex/flex-main.scss");
require("shared/sass/flex/PortalHacks.scss");
require("shared/sass/sections/roles.scss");
require("shared/sass/sections/user-management.scss");
require("shared/sass/sections/events.scss");
require("shared/css/react-bootstrap-table.css");
require("shared/css/insights.css");
require("shared/css/toastr.css");
require("shared/css/ladda-themeless.min.css");
require("shared/css/react-datetime.css");
require("shared/css/animate.min.css");
require("shared/css/ajaxLoader.css");
require("shared/css/odometer-theme-default.css");
require("shared/css/image-gallery.css");
require("shared/css/slick/slick.css");
require("shared/css/slick/slick-theme.css");
require("shared/css/react-select.css");
require("shared/css/filetransfer.css");
require("shared/css/disclosures.css");
require("shared/css/inspection-editor.css");
require("shared/sass/components/cronFormatter.scss");
require("shared/sass/components/filetransfer/filetransferupload-admin.scss");
require("skins/default/css/skin.scss");
require("shared/css/new-filetransfer.css");
require("shared/css/web-scanner.css");
require("shared/css/_program-tracker.scss");
require("shared/css/fleetModule.css");
require("shared/css/performance-scorecard.css");
require.context("shared/img", true, /.*/);
require.context("skins", true, /.*/);

let flex = require("./util");
flex.lib = {};
flex.rx = {};
flex.components = {};
flex.AppContainer = {};
flex.dashboardParts = [];

// Set these after the export, to prevent {} due to circular references
window.flex = flex;

flex.lib = require("./lib.jsx");
flex.rx = require("./rx.js");

require('./formsyConfig')(flex.lib.Formsy);
flex.tracking = require('./Tracking')();
flex.tracking.registerModule(require('./globalTracking')());
flex.globalConstants = require('./constants');
flex.browserHistory = require('./browserHistory.js').default;

require('./Request')();
require('./environment')();

flex.components = require("./components.jsx");
